import StoreCoffre from '../assets/ProtectionsSolaire/Stores/StoreAvecCoffre.png'
import StoreSansCoffre from '../assets/ProtectionsSolaire/Stores/StoreSansCoffre.png'

export const stores = {
    storesBannes: {
        titre: "Stores bannes",
        // eslint-disable-next-line
        intro: "Les stores bannes permettent de créer facilement une zone d’ombre agréable sur une terrasse, un balcon ou une façade exposée au soleil. Ils protègent efficacement des rayons directs tout en apportant une touche esthétique à votre extérieur.\
        Conçus avec une structure en aluminium résistante et des toiles techniques durables, nos stores bannes allient confort, fiabilité et design moderne.",
        items: [
            {
                titre: "Store banne sans coffre",
                image: StoreSansCoffre,
                intro: "Protection solaire simple et efficace",
                // eslint-disable-next-line
                presentation: "Le store banne sans coffre est une solution idéale pour créer une zone d’ombre confortable sur une terrasse ou un balcon. \
                Grâce à son système à bras articulés, la toile se déploie facilement pour protéger efficacement du soleil tout en conservant un design discret. \
                Ce modèle constitue une solution fiable et économique pour aménager durablement un espace extérieur.",
                disponibilites: [
                    "Formats dipsonibles : 3x2m 4x2,5m 5x3m",
                    "Fabrication possible sur mesure selon votre projet",
                    "Disponible en version manuelle ou motorisée"
                ],
                fiche: null,
                prix: "Chaque projet étant unique, le prix est établi sur devis",
                conclusion: "Conçu pour offrir une protection solaire efficace, ce store banne se distingue par sa structure en aluminium résistante et sa toile technique durable, garantissant confort d’utilisation et longévité."
            },
            {
                titre: "Store banne avec coffre",
                image: StoreCoffre,
                intro: "Protection maximale et design premium",
                // eslint-disable-next-line
                presentation: "Le store banne avec coffre protège entièrement la toile et le mécanisme lorsque le store est fermé. Ce système garantit une meilleure durabilité et un rendu esthétique plus moderne sur la façade. \
                Idéal pour les terrasses exposées au soleil, il permet de créer un espace extérieur confortable et élégant.",
                disponibilites: [
                    "Formats dipsonibles : 3x2m 4x2,5m 5x3m 6x3,5m",
                    "Fabrication possible sur mesure selon votre projet",
                    "Disponible en version motorisée avec télécommande"
                ],
                fiche: null,
                prix: "Chaque projet étant unique, le prix est établi sur devis",
                conclusion: "Équipé d’un éclairage LED intégré, il permet de profiter de votre terrasse même en soirée, tout en offrant une protection optimale de la toile grâce à son coffre intégral."
            },
        ]
    }
}